import React from 'react'

export default function UpWorkIcon() {
   return (
      <svg
         width="49"
         height="49"
         viewBox="0 0 49 49"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M24.2773 0.550293C11.0193 0.550293 0.277344 11.2922 0.277344 24.5503C0.277344 37.8084 11.0193 48.5503 24.2773 48.5503C37.5354 48.5503 48.2773 37.8084 48.2773 24.5503C48.2773 11.2922 37.5354 0.550293 24.2773 0.550293ZM33.858 31.9051C31.9225 31.9051 30.2773 31.3245 28.8257 30.4535L27.1806 38.1955H23.4064L25.729 27.5503C24.7612 26.1955 23.7935 24.6471 23.1161 23.1955V24.8406C23.1161 28.8084 19.9225 32.0019 16.0515 32.0019C12.1806 32.0019 8.98702 28.8084 8.98702 24.8406V15.1632H12.6644V24.8406C12.6644 26.7761 14.2128 28.3245 16.1483 28.3245C18.0838 28.3245 19.6322 26.7761 19.6322 24.8406V15.1632H23.3096C24.0838 17.5826 25.3419 20.4858 26.987 23.0987C27.9548 19.4213 30.6644 17.1955 34.0515 17.1955C38.0193 17.1955 41.3096 20.4858 41.3096 24.4535C41.1161 28.6148 37.8257 31.9051 33.858 31.9051Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
